import { TripRead } from 'src/common/external/bambi-api/bambiApi';
import { Skeleton } from 'src/common/Skeleton';

interface TripDetailsExternalTripIdProps {
  isTripDataLoading: boolean;
  tripData?: TripRead;
}

export function TripDetailsExternalTripId({
  isTripDataLoading,
  tripData,
}: TripDetailsExternalTripIdProps) {
  if (!tripData?.external_trip_id) {
    return null;
  }

  return (
    <div className="flex flex-col gap-1 py-2">
      <h4 className="text-sm font-bold">External Trip ID</h4>
      {isTripDataLoading ? (
        <Skeleton />
      ) : (
        <div className="text-sm">
          <p className="text-sm font-medium text-gray-500">
            {tripData.external_trip_id}
          </p>
        </div>
      )}
    </div>
  );
}
